/**
 * Utility functions for preflight operations
 * Replicates the backbone logic from asset_list_module.js and helpers.js
 */

/**
 * Generate generic preflight payload for resources
 * Replicates the RM.getGenericPreflightPayload function from helpers.js
 *
 * @param {Array} resources - Array of resource IDs
 * @param {string} preflightType - Type of preflight (e.g., 'source_config', 'source', 'migration_profile')
 * @param {Object} overrides - Override options for the preflight
 * @returns {Array} Array of preflight payload objects
 */
export const getGenericPreflightPayload = (resources, preflightType, overrides = {}) => {
    return resources.map((id) => {
        const payloadObj = {
            type: preflightType,
            resource_id: id,
            overrides: overrides,
        };

        return payloadObj;
    });
};

/**
 * Create preflight payload for CSV migration profile
 * Replicates the logic from asset_list_module.js updateConfigsAndRunPreflight
 *
 * @param {Object} migrationProfile - Migration profile data
 * @param {boolean} ignoreValidationErrors - Whether to ignore validation errors
 * @returns {Array} Preflight payload array
 */
export const createCsvMigrationPreflightPayload = (migrationProfile, ignoreValidationErrors = false) => {
    if (!migrationProfile || !migrationProfile.sources) {
        return [];
    }

    // Create preflight payload for source configs with resource data
    const sourceConfigPayloads = migrationProfile.sources.map((source) => {
        const overrides = {};
        const volumeTypes = source.target_config?.vm_details?.volume_types;

        if (!!volumeTypes) {
            overrides.volume_types = [volumeTypes];
        }

        return {
            type: 'source_config',
            resource_id: source.id,
            overrides,
            // Include the actual source data for name resolution
            sourceData: source,
        };
    });

    // Add migration profile preflight with resource data
    const migrationProfilePayload = {
        type: 'migration_profile',
        resource_id: migrationProfile.id,
        overrides: {
            ignore_validation_errors: ignoreValidationErrors,
        },
        // Include the migration profile data for name resolution
        sourceData: {
            id: migrationProfile.id,
            name:
                migrationProfile.name || `CSV migrations - ${new Date().toISOString().slice(0, 19).replace('T', ' ')}`,
        },
    };

    return [...sourceConfigPayloads, migrationProfilePayload];
};
